import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProjektService } from '../service';

@Component({
  selector: 'fa-kt-projekt-detail',
  templateUrl: './projekt-detail.component.html',
  styleUrls: ['./projekt-detail.component.css'],
})
export class ProjektDetailComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  constructor(public projekt: ProjektService) {}
}
